<script setup lang="ts">
import { defineProps } from "vue";
import PriceModelCurveDO = Modules.BookingExperts.Data.PriceModelCurve.PriceModelCurveDO;
import { t } from "../../../../plugins/i18n";

const props = defineProps<{
	curves: PriceModelCurveDO[];
}>();
</script>

<template>
	<v-card>
		<v-card-title class="headline">Curve Legend</v-card-title>
		<v-divider />
		<v-card-text>
			<div class="legend">
				<div v-for="curve in props.curves" :key="curve.id" class="legend-item">
					<span class="chit" :style="{ backgroundColor: curve.color }"></span>
					<div class="curve-info">
						<span class="curve-name">
							{{ curve.name }}
						</span>
						<span class="text-medium-emphasis text-sm-caption">
							Type: {{ t(`pricelist.curves.${curve.type}`) }}
						</span>
						<span class="text-medium-emphasis text-sm-caption">
							Price adjustment:
							{{
								t(
									`pricelist.curves.price_adjustment_type.${curve.price_adjustment_type}`
								)
							}}
						</span>
						<span class="text-medium-emphasis text-sm-caption">
							<template v-if="curve.yoy_options.mode === 'target'">
								Target: {{ curve.yoy_options.scaleTarget }}%
							</template>
							<template v-if="curve.yoy_options.mode === 'offset'">
								Offset:
								<span v-if="curve.yoy_options.scaleOffset >= 0">
									+{{ Math.abs(curve.yoy_options.scaleOffset) }}%
								</span>
								<span v-if="curve.yoy_options.scaleOffset < 0">
									-{{ Math.abs(curve.yoy_options.scaleOffset) }}%
								</span>
							</template>
						</span>
					</div>
					<v-spacer />
					<span
						class="cursor-help"
						v-if="curve.description && curve.description.length > 0"
						v-tooltip="`${curve.description}`"
					>
						<v-icon class="fa-regular fa-message-question" />
					</span>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<style scoped>
.legend {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
	gap: 1rem;
}

.chit {
	background: #f8f8f8;
	border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
	border-radius: 10px;
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5),
		inset 0 -1px 2px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1);
	min-height: 15px;
	min-width: 15px;
}

.legend-item {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	padding: 0.5rem;
	border: 1px solid rgb(var(--color-secondary));
	border-radius: 8px;
	background-color: rgb(var(--color-background));
	max-width: 300px;
	text-overflow: ellipsis;
	overflow: hidden;
}

.curve-info {
	display: flex;
	flex-direction: column;
}

.curve-name {
	font-weight: 500;
}

.curve-description {
	font-size: 0.875rem;
	color: #757575;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 200px;
}
</style>
